import React from "react";

const TranscribeIcon = ({ reTranscribe = false, disabled = false }) =>
  reTranscribe ? (
    disabled ? (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28.275"
        height="25.363"
        viewBox="0 0 28.275 25.363"
      >
        <g
          id="Group_1150"
          data-name="Group 1150"
          transform="translate(-1265.081 -435.041)"
        >
          <g id="cnt" transform="translate(1265.081 435.041)">
            <path
              id="Path_1"
              data-name="Path 1"
              d="M3.069,21.919a3.059,3.059,0,0,0,3.024-2.63H11.4V13.983a3.053,3.053,0,0,0,0-6.048V3.507h4.429a3.069,3.069,0,1,0,0-.877H10.521V7.936a3.053,3.053,0,0,0,0,6.048v4.429H6.093a3.063,3.063,0,1,0-3.024,3.507Z"
              fill="#B5B5B5"
            />
          </g>
          <g id="rld_ic" transform="translate(1278.514 443.395)">
            <path
              id="Path_1222"
              data-name="Path 1222"
              d="M2.683,52.24l-.2,2.161a.3.3,0,0,0,.443.3l.6-.3a5.808,5.808,0,0,0,10.7-1,.48.48,0,0,0-.456-.612.489.489,0,0,0-.456.338,4.858,4.858,0,0,1-8.942.846l.612-.312a.306.306,0,0,0,.026-.534L3.152,52.006A.313.313,0,0,0,2.683,52.24Z"
              transform="translate(0 -40.502)"
              fill="#B5B5B5"
            />
            <path
              id="Path_1223"
              data-name="Path 1223"
              d="M12.725,5.4A5.815,5.815,0,0,0,7.167,9.513a.48.48,0,0,0,.456.612.489.489,0,0,0,.456-.338A4.858,4.858,0,0,1,17.02,8.94l-.612.312a.306.306,0,0,0-.026.534l1.848,1.119a.313.313,0,0,0,.469-.234l.2-2.148a.3.3,0,0,0-.443-.3l-.6.3A5.771,5.771,0,0,0,12.725,5.4Z"
              transform="translate(-4.055 0)"
              fill="#B5B5B5"
            />
          </g>
        </g>
      </svg>
    ) : (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28.275"
        height="25.363"
        viewBox="0 0 28.275 25.363"
      >
        <g
          id="Group_1150"
          data-name="Group 1150"
          transform="translate(-1265.081 -435.041)"
        >
          <g id="cnt" transform="translate(1265.081 435.041)">
            <path
              id="Path_1"
              data-name="Path 1"
              d="M3.069,21.919a3.059,3.059,0,0,0,3.024-2.63H11.4V13.983a3.053,3.053,0,0,0,0-6.048V3.507h4.429a3.069,3.069,0,1,0,0-.877H10.521V7.936a3.053,3.053,0,0,0,0,6.048v4.429H6.093a3.063,3.063,0,1,0-3.024,3.507Z"
            />
          </g>
          <g id="rld_ic" transform="translate(1278.514 443.395)">
            <path
              id="Path_1222"
              data-name="Path 1222"
              d="M2.683,52.24l-.2,2.161a.3.3,0,0,0,.443.3l.6-.3a5.808,5.808,0,0,0,10.7-1,.48.48,0,0,0-.456-.612.489.489,0,0,0-.456.338,4.858,4.858,0,0,1-8.942.846l.612-.312a.306.306,0,0,0,.026-.534L3.152,52.006A.313.313,0,0,0,2.683,52.24Z"
              transform="translate(0 -40.502)"
            />
            <path
              id="Path_1223"
              data-name="Path 1223"
              d="M12.725,5.4A5.815,5.815,0,0,0,7.167,9.513a.48.48,0,0,0,.456.612.489.489,0,0,0,.456-.338A4.858,4.858,0,0,1,17.02,8.94l-.612.312a.306.306,0,0,0-.026.534l1.848,1.119a.313.313,0,0,0,.469-.234l.2-2.148a.3.3,0,0,0-.443-.3l-.6.3A5.771,5.771,0,0,0,12.725,5.4Z"
              transform="translate(-4.055 0)"
            />
          </g>
        </g>
      </svg>
    )
  ) : disabled ? (
    <svg
      id="cnt"
      xmlns="http://www.w3.org/2000/svg"
      width="21.919"
      height="21.919"
      viewBox="0 0 21.919 21.919"
    >
      <path
        id="Path_1"
        data-name="Path 1"
        d="M3.069,21.919a3.059,3.059,0,0,0,3.024-2.63H11.4V13.983a3.053,3.053,0,0,0,0-6.048V3.507h4.429a3.069,3.069,0,1,0,0-.877H10.521V7.936a3.053,3.053,0,0,0,0,6.048v4.429H6.093a3.063,3.063,0,1,0-3.024,3.507Z"
        fill="#B5B5B5"
      />
    </svg>
  ) : (
    <svg
      id="cnt"
      xmlns="http://www.w3.org/2000/svg"
      width="21.919"
      height="21.919"
      viewBox="0 0 21.919 21.919"
    >
      <path
        id="Path_1"
        data-name="Path 1"
        d="M3.069,21.919a3.059,3.059,0,0,0,3.024-2.63H11.4V13.983a3.053,3.053,0,0,0,0-6.048V3.507h4.429a3.069,3.069,0,1,0,0-.877H10.521V7.936a3.053,3.053,0,0,0,0,6.048v4.429H6.093a3.063,3.063,0,1,0-3.024,3.507Z"
      />
    </svg>
  );
export default TranscribeIcon;
